import React from "react";
import { observer } from "mobx-react-lite";
import { ViewDocument } from "../../components/templates/ViewDocument";
import { TypeContractEnum } from "../../enum/contract";
import { env } from "../../config";

const ContractVivoPayAwardViewer: React.FC = observer(() => (
	<ViewDocument url={env.blob.vivoPayAwardTermURL} type={TypeContractEnum.VIVO_PAY_AWARD} />
));

export default ContractVivoPayAwardViewer;
